export type ReportType = 'UXO' | 'SRE';

// The possible identification keys that belong to SRE reports rather than UXO reports.
export const SRE_IDENTIFICATION_KEYS: ReadonlySet<string> = new Set([
  'OTHER_POSSIBLE_OSSEOUS_MATERIAL',
  'OTHER_POSSIBLE_MATERIAL_EVIDENCE',
  'OTHER_POSSIBLE_LIFE_SUPPORT_EQUIPMENT',
  'OTHER_POSSIBLE_AIRCRAFT_WRECKAGE',
]);

export function isSreIdentificationKey(key: string | null | undefined): boolean {
  return key != null && SRE_IDENTIFICATION_KEYS.has(key);
}

/**
 * The Ordnance Search groups to show for a report type.
 *
 * UXO reports are offered every item except the SRE ones (Possible Osseous
 * Material, Possible Material Evidence, Possible Life Support Equipment).
 * SRE reports are offered only the SRE ones. Groups left with no items are
 * dropped. Anything other than 'SRE' is treated as UXO. The groups passed in
 * are not changed.
 */
export function groupsForReportType<T extends { items: { key: string }[] }>(
  groups: T[],
  reportType: ReportType | string | null | undefined,
): T[] {
  const wantsSre = reportType === 'SRE';

  return groups
    .map((group) => ({
      ...group,
      items: group.items.filter(
        (item) => isSreIdentificationKey(item.key) === wantsSre,
      ),
    }))
    .filter((group) => group.items.length > 0);
}
